import JsonViewer from './JsonViewer';

export default JsonViewer;
